"use strict";

(function () {
  let titleClick = document.querySelectorAll(".js-footer-nav-title");
  let searchForm = document.querySelector('.js-footer-subscribe-form');
  titleClick.forEach(el => {
    let arrow = el.querySelector(".footer-navigation__icon");
    let list = el.nextElementSibling;
    el.addEventListener('click', function () {
      list.classList.toggle("visibility-toggle");
      arrow.classList.toggle("close");
    });
  });
  searchForm.addEventListener('submit', function (evt) {
    let searchInput = searchForm.querySelector('.footer-subscribe__input');
    if (searchInput.value == '') evt.preventDefault();
  });
})();